import dateFns from 'date-fns';
import { getHandler, patchHandler, deleteHandler, postHandler } from 'src/utils/fetchHandler';
import {
	getPendingActivityUpdate,
	getPendingActivityDelete,
	getPendingActivityCreate,
} from './activity.selector';

export const CLEAR_ACTIVITIES = 'CLEAR_ACTIVITIES/ACTIVITY/@WISELY/WEB';
export const CLEAR_ACTIVITY_UPDATE_ERRORS = 'CLEAR_ACTIVITY_UPDATE_ERRORS/ACTIVITY/@WISELY/WEB';
export const CLEAR_ACTIVITY_CREATE_ERRORS = 'CLEAR_ACTIVITY_CREATE_ERRORS/ACTIVITY/@WISELY/WEB';
export const GET_ACTIVITIES = 'GET_ACTIVITIES/ACTIVITY/@WISELY/WEB';
export const FETCH_ACTIVITIES_SUCCEEDED = 'FETCH_ACTIVITIES_SUCCEEDED/ACTIVITY/@WISELY/WEB';
export const FETCH_ACTIVITIES_FAILED = 'FETCH_ACTIVITIES_FAILED/ACTIVITY/@WISELY/WEB';
export const UPDATE_ACTIVITY = 'UPDATE_ACTIVITY/ACTIVITY/@WISELY/WEB';
export const UPDATE_ACTIVITY_SUCCEEDED = 'UPDATE_ACTIVITY_SUCCEEDED/ACTIVITY/@WISELY/WEB';
export const UPDATE_ACTIVITY_FAILED = 'UPDATE_ACTIVITY_FAILED/ACTIVITY/@WISELY/WEB';
export const DELETE_ACTIVITY = 'DELETE_ACTIVITY/ACTIVITY/@WISELY/WEB';
export const DELETE_ACTIVITY_SUCCEEDED = 'DELETE_ACTIVITY_SUCCEEDED/ACTIVITY/@WISELY/WEB';
export const DELETE_ACTIVITY_FAILED = 'DELETE_ACTIVITY_FAILED/ACTIVITY/@WISELY/WEB';
export const CREATE_ACTIVITY = 'CREATE_ACTIVITY/ACTIVITY/@WISELY/WEB';
export const CREATE_ACTIVITY_SUCCEEDED = 'CREATE_ACTIVITY_SUCCEEDED/ACTIVITY/@WISELY/WEB';
export const CREATE_ACTIVITY_FAILED = 'CREATE_ACTIVITY_FAILED/ACTIVITY/@WISELY/WEB';
export const GET_ACTIVITIES_TODAY = 'GET_ACTIVITIES_TODAY/ACTIVITY/@WISELY/WEB';
export const FETCH_ACTIVITIES_TODAY_SUCCEEDED =
	'FETCH_ACTIVITIES_TODAY_SUCCEEDED/ACTIVITY/@WISELY/WEB';
export const FETCH_ACTIVITIES_TODAY_FAILED = 'FETCH_ACTIVITIES_TODAY_FAILED/ACTIVITY/@WISELY/WEB';
export const GET_ACTIVITIES_THIS_WEEK = 'GET_ACTIVITIES_THIS_WEEK/ACTIVITY/@WISELY/WEB';
export const FETCH_ACTIVITIES_THIS_WEEK_SUCCEEDED =
	'FETCH_ACTIVITIES_THIS_WEEK_SUCCEEDED/ACTIVITY/@WISELY/WEB';
export const FETCH_ACTIVITIES_THIS_WEEK_FAILED =
	'FETCH_ACTIVITIES_THIS_WEEK_FAILED/ACTIVITY/@WISELY/WEB';

export const clearActivities = () => ({
	type: CLEAR_ACTIVITIES,
});

export const clearActivityUpdateErrors = () => ({
	type: CLEAR_ACTIVITY_UPDATE_ERRORS,
});

export const clearActivityCreateErrors = () => ({
	type: CLEAR_ACTIVITY_CREATE_ERRORS,
});

export const getActivities = () => ({
	type: GET_ACTIVITIES,
});

export const fetchActivitiesSucceeded = payload => ({
	type: FETCH_ACTIVITIES_SUCCEEDED,
	payload,
});

export const fetchActivitiesFailed = payload => ({
	type: FETCH_ACTIVITIES_FAILED,
	payload,
});

export const fetchActivities = params => {
	return async dispatch => {
		dispatch(getActivities());
		const path = 'v2/activities';

		return getHandler(path, params)
			.then(json => dispatch(fetchActivitiesSucceeded(json)))
			.catch(error => {
				console.error('fetchActivities error', error);
				dispatch(fetchActivitiesFailed(error));
			});
	};
};

export const getActivitiesToday = () => ({
	type: GET_ACTIVITIES_TODAY,
});

export const fetchActivitiesTodaySucceeded = payload => ({
	type: FETCH_ACTIVITIES_TODAY_SUCCEEDED,
	payload,
});

export const fetchActivitiesTodayFailed = payload => ({
	type: FETCH_ACTIVITIES_TODAY_FAILED,
	payload,
});

export const fetchActivitiesToday = fundraisers => {
	return async dispatch => {
		dispatch(getActivitiesToday());

		const path = 'v2/activities';
		const params = {
			fundraisers,
			date: {
				$gte: dateFns.startOfToday().toISOString(),
				$lt: dateFns.endOfToday().toISOString(),
			},
			completed: { $ne: true },
			$sort: { date: -1 },
		};

		return getHandler(path, params)
			.then(json => dispatch(fetchActivitiesTodaySucceeded(json.total)))
			.catch(error => {
				console.error('fetchActivitiesToday error', error);
				dispatch(fetchActivitiesTodayFailed(error));
			});
	};
};

export const getActivitiesThisWeek = () => ({
	type: GET_ACTIVITIES_THIS_WEEK,
});

export const fetchActivitiesThisWeekSucceeded = payload => ({
	type: FETCH_ACTIVITIES_THIS_WEEK_SUCCEEDED,
	payload,
});

export const fetchActivitiesThisWeekFailed = payload => ({
	type: FETCH_ACTIVITIES_THIS_WEEK_FAILED,
	payload,
});

export const fetchActivitiesThisWeek = fundraisers => {
	return async dispatch => {
		dispatch(getActivitiesThisWeek());

		const path = 'v2/activities';
		const params = {
			fundraisers,
			date: {
				$gte: dateFns.startOfWeek(new Date().toISOString()),
				$lte: dateFns.endOfWeek(new Date().toISOString()),
			},
			completed: { $ne: true },
			$sort: { date: -1 },
		};

		return getHandler(path, params)
			.then(json => dispatch(fetchActivitiesThisWeekSucceeded(json.total)))
			.catch(error => {
				console.error('fetchActivitiesThisWeek error', error);
				dispatch(fetchActivitiesThisWeekFailed(error));
			});
	};
};

export const updateActivity = () => ({
	type: UPDATE_ACTIVITY,
});

export const requestUpdateActivitySucceeded = payload => ({
	type: UPDATE_ACTIVITY_SUCCEEDED,
	payload,
});

export const requestUpdateActivityFailed = payload => ({
	type: UPDATE_ACTIVITY_FAILED,
	payload,
});

export const requestUpdateActivity = (id, body) => {
	return async (dispatch, getState) => {
		if (getPendingActivityUpdate(getState())) {
			return;
		}
		dispatch(updateActivity());
		const path = `v2/activities/${id}`;

		return patchHandler(path, JSON.stringify(body))
			.then(json => dispatch(requestUpdateActivitySucceeded(json)))
			.catch(error => {
				console.error('requestUpdateActivity error', error);
				return dispatch(requestUpdateActivityFailed(error));
			});
	};
};

export const deleteActivity = () => ({
	type: DELETE_ACTIVITY,
});

export const requestDeleteActivitySucceeded = payload => ({
	type: DELETE_ACTIVITY_SUCCEEDED,
	payload,
});

export const requestDeleteActivityFailed = payload => ({
	type: DELETE_ACTIVITY_FAILED,
	payload,
});

export const requestDeleteActivity = id => {
	return async (dispatch, getState) => {
		if (getPendingActivityDelete(getState())) {
			return;
		}
		dispatch(deleteActivity());
		const path = `v2/activities/${id}`;

		return deleteHandler(path)
			.then(json => dispatch(requestDeleteActivitySucceeded(json)))
			.catch(error => {
				console.error('requestDeleteActivityFailed error', error);
				dispatch(requestDeleteActivityFailed(error));
			});
	};
};

export const createActivity = () => ({
	type: CREATE_ACTIVITY,
});

export const requestCreateActivitySucceeded = payload => ({
	type: CREATE_ACTIVITY_SUCCEEDED,
	payload,
});

export const requestCreateActivityFailed = payload => ({
	type: CREATE_ACTIVITY_FAILED,
	payload,
});

export const requestCreateActivity = body => {
	return async (dispatch, getState) => {
		if (getPendingActivityCreate(getState())) {
			return;
		}
		dispatch(createActivity());
		const path = 'v2/activities';

		return postHandler(path, JSON.stringify(body))
			.then(json => dispatch(requestCreateActivitySucceeded(json)))
			.catch(error => {
				console.error('requestCreateActivity error', error);
				return dispatch(requestCreateActivityFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/activities/activity.action.js